import { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormLabel,
  Modal,
  TextField,
} from "@mui/material";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { errorToastMessage, toastMessage } from "../../utils/toast";
import {
  ModalDrawerButtonStyles,
  ModalDrawerStyles,
  ModalHeader,
} from "../Common/styles/modal";
import { InputWrapper, LabelStyle } from "../Common/styles/form";
import { DrawerForm } from "../Common/styles/drawer";
import http from "../../utils/http";
import { useParams } from "react-router-dom";
import { AxiosResponse } from "axios";

let schema = yup.object().shape({
  name: yup.string().required("Form Name is Required").trim(),
  description: yup.string().optional(),
});

const AddScreeningFormModal = ({
  showModal,
  closeModal,
  data,
  phaseId,
  refreshPage,
  formId,
  type,
}: any) => {
  const [submitLoader, setSubmitLoader] = useState(false);
  const { id: studyId } = useParams();

  const submitHandler = async (values: any) => {
    try {
      setSubmitLoader(true);
      const body = {
        ...values,
      };
      let formPhaseId = phaseId;

      const prefix =
        type === "platform" ? "/admin/registry/" : `/study/${studyId}/`;
      const phase = type === "platform" ? "registry-phase" : "study-phase";
      if (!formPhaseId) {
        const phaseRes: AxiosResponse = await http.post(`${prefix}${phase}`, {
          name: "Screening",
          category: "screening",
        });
        formPhaseId = phaseRes.data?.data?.id;
      }

      if (formId) {
        await http.patch(`${prefix}forms/${formId}`, body);
      } else {
        await http.post(`${prefix}${phase}/${formPhaseId}/phase_form`, body);
      }
      closeModal();
      toastMessage(
        "success",
        formId ? "Form updated successfully" : "Form created successfully"
      );

      setSubmitLoader(false);
      refreshPage();
    } catch (err) {
      errorToastMessage(err as Error);
      setSubmitLoader(false);
    }
  };

  return (
    <Modal open={showModal} onClose={closeModal}>
      <Box sx={ModalDrawerStyles}>
        <ModalHeader
          title={formId ? "Edit Form" : "Add Form"}
          onCloseClick={closeModal}
        />

        <Formik
          initialValues={{
            name: data?.name || "",
            description: data?.description || "",
          }}
          validationSchema={schema}
          onSubmit={(values) => {
            submitHandler(values);
          }}
        >
          {({ getFieldProps, errors, touched }) => (
            <Form style={DrawerForm}>
              <FormControl sx={InputWrapper}>
                <FormLabel sx={LabelStyle} htmlFor="form-name">
                  Form Name <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <TextField
                  placeholder="Form name"
                  id="form-name"
                  {...getFieldProps("name")}
                  error={touched?.name && errors?.name ? true : false}
                  helperText={
                    touched?.name && errors?.name
                      ? (errors?.name as string)
                      : " "
                  }
                />
              </FormControl>
              <FormControl sx={InputWrapper}>
                <FormLabel sx={LabelStyle} htmlFor="description">
                  Form Description
                </FormLabel>
                <TextField
                  multiline
                  rows={4}
                  placeholder="Form description"
                  id="description"
                  {...getFieldProps("description")}
                  error={
                    touched?.description && errors?.description ? true : false
                  }
                  helperText={
                    touched?.description && errors?.description
                      ? (errors?.description as string)
                      : " "
                  }
                />
              </FormControl>
              <Box sx={{ mt: "auto" }}>
                <Divider />
                <Box sx={ModalDrawerButtonStyles}>
                  {!submitLoader ? (
                    <>
                      <Button onClick={closeModal} variant="outlined">
                        Cancel
                      </Button>
                      <Button type="submit" variant="contained">
                        {formId ? "Save" : "Add"}
                      </Button>
                    </>
                  ) : (
                    <CircularProgress size={25} />
                  )}
                </Box>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};

export default AddScreeningFormModal;
